import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-account-name',
  templateUrl: './nested-account-name.component.html',
  styleUrls: ['./nested-account-name.component.scss']
})
export class NestedAccountNameComponent implements OnInit {
    @Input() nestLevel = 0;
    @Input() name = '';

    constructor() { }

    ngOnInit(): void {
    }

    createDummyArray(length: number) {
        return new Array(length);
    }
}
